var NA_IMAGES = {
  "icon-small": require("../../img/icon-service-default-small@2x.png"),
  "icon-medium": require("../../img/icon-service-default-medium@2x.png"),
  "icon-large": require("../../img/icon-service-default-large@2x.png")
};

var MARATHON_IMAGES = {
  "icon-small": require("../../img/icon-service-marathon-small@2x.png"),
  "icon-medium": require("../../img/icon-service-marathon-medium@2x.png"),
  "icon-large": require("../../img/icon-service-marathon-large@2x.png")
};

module.exports.NA_IMAGES = NA_IMAGES;
module.exports.MARATHON_IMAGES = MARATHON_IMAGES;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/ServiceImages.js